"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spy = void 0;
class Spy {
    constructor(inCallback, outCallback) {
        this.inCallback = inCallback;
        this.outCallback = outCallback;
    }
    /**
     *
     * @param element
     * @param options
     */
    createObserver(element, options) {
        options = Object.assign({
            root: null,
            rootMargin: '0px',
            threshold: Spy.buildThresholdList(),
        }, options);
        this.observer = new IntersectionObserver(this.handleIntersect.bind(this), options);
        this.observer.observe(element);
    }
    /**
     *
     * @param entries
     */
    handleIntersect(entries) {
        let prevRatio = 0.0;
        entries.forEach((entry) => {
            if (entry.intersectionRatio > prevRatio) {
                this.inCallback.call(this, entry.target);
            }
            else {
                this.outCallback.call(this, entry.target);
            }
            prevRatio = entry.intersectionRatio;
        });
    }
    /**
     *
     */
    static buildThresholdList() {
        const thresholds = [];
        const numSteps = 20;
        for (let i = 1.0; i <= numSteps; i++) {
            const ratio = i / numSteps;
            thresholds.push(ratio);
        }
        thresholds.push(0);
        return thresholds;
    }
}
exports.Spy = Spy;
